angular.module('picmonicng').factory('ExamOptionsConfig', [
  '$resource',
  function ($resource) {
    return {
      exams: [
        { id: 1, name: 'USMLE Step 1', lead: 100 },
        { id: 2, name: 'USMLE Step 2', lead: 100 },
        { id: 3, name: 'USMLE Step 3', lead: 100 },
        { id: 4, name: 'COMLEX Step 1', lead: 100 },
        { id: 5, name: 'AANC', lead: 101 },
        { id: 6, name: 'AANP', lead: 101 },
        { id: 7, name: 'NCLEX ® - RN', lead: 101 },
        { id: 8, name: 'MCAT', lead: 103 },
        { id: 9, name: 'NAPLEX', lead: 109 },
        { id: 9, name: 'PTCE', lead: 109 },
        { id: 10, name: 'PANCE', lead: 105 },
        { id: 12, name: 'PANRE', lead: 105 },
        { id: 11, name: 'COMLEX Step 2', lead: 100 },
        { id: 12, name: 'NAPLEX®', lead: 109 },
      ],
    };
  },
]);
